import React, { useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import { DE } from '../Languages/DE';
import { EN } from '../Languages/EN';
import { isLanguageSupported } from '../Languages/index';
import { Link, useHistory, useLocation } from "react-router-dom";
import { string } from 'prop-types';
import { Modal } from 'react-bootstrap';
import { LoadingDots } from '../LoadingDots/LoadingDots';
import { $crud } from '../helper/CrudFactory';
import { callAPI } from '../helper/apiUtils';
import { RIGHT_TOP, SET_OPEN_SIDE_BAR, SET_USER, SET_USER_LOGIN_TOKEN, store } from '../store';
import { useDispatch } from 'react-redux';
import { TOGGLE_DRAWER } from '../helper/constants';
import { $user } from '../helper/UserFactory';
import { queueStartupNavigation } from '../utils/startupScreen';
import "./SecurityPIN.css";


function SecurityPIN(props) {
    const [otp, setOtp] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [msg, setMsg] = useState('')
    const [errorModal, setShowModalError] = useState(false)
    const [isGerms, setIsGerm] = useState(true);
    const history = useHistory();
    const [isInvalid, setIsInvalid] = useState(false);
    const [invalidMsg, setInvalidMsg] = useState("");
    const [user, setUser] = useState("");
    const dispatch = useDispatch()
    let state = history.location.state
    const [loading, setLoading] = useState(false);

    const handleChange = (otp) => {
        setInvalidMsg('');
        setIsInvalid(false);
        setOtp(otp)
    };
    useEffect(() => {
        console.log(state)
        let registerLang = localStorage.getItem("regiLang");
        if (registerLang) {
            setIsGerm(registerLang == 2 ? true : false);
        }
    }, [])
    const _handleConfirm = async () => {
        if (state.isRegister) {
            try {
                console.log({ ...state, userPin: otp })
                setLoading(true)
                state.lang = localStorage.getItem("regiLang") == 2 ? "de" : "en";
                console.log(state)
                const data = await $crud.post("/auth/registerKjuupUser", { ...state, userPin: otp });
                if (!data.status) {
                    setInvalidMsg(data.message);
                    setIsInvalid(true);
                    setLoading(false)
                } else {
                    await localStorage.setItem("token", data.token);
                    if (data.refreshToken) localStorage.setItem("refreshToken", data.refreshToken);
                    // Use stored language preference, not just isGerms boolean
                    var storedLang = localStorage.getItem("language");
                    // Check if stored language is supported (all 22 languages)
                    var userLang = (storedLang && isLanguageSupported(storedLang)) ? storedLang : (isGerms ? "de" : "en");
                    let filterUser = { ...data.user, language: userLang };
                    console.log("filterUser=>", filterUser);
                    localStorage.setItem("user", JSON.stringify(filterUser));
                    let PROJECT = isGerms ? DE.project : EN.project;
                    let OTHERS = isGerms ? DE.Others : EN.Others;
                    // var form = new FormData();
                    let params = {
                        name: PROJECT + " " + filterUser?.lastName,
                        buildingType: OTHERS,
                        street: "Niebuhrstraße",
                        postCode: "53113",
                        city: "Bonn",
                        country: "Germany",
                        lat: 50.7262322,
                        long: 7.10846,
                        houseNo: "52",
                        isFirstProject: true,
                        isHidden: true
                    };
                    // const datax = await callAPI("/building", params, "POST");
                    await localStorage.removeItem("regiLang");
                    store.dispatch({
                        type: SET_USER,
                        user: data.user,
                    });
                    setLoading(false)
                    const startup = queueStartupNavigation(data?.user?.startupScreen);
                    dispatch({ type: TOGGLE_DRAWER, open: true })
                    dispatch({ type: RIGHT_TOP, rightTop: '' })
                    dispatch({ type: SET_OPEN_SIDE_BAR, payload: startup.sidebar })
                    dispatch({ type: SET_USER, user: filterUser });
                    dispatch({ type: SET_USER_LOGIN_TOKEN, status: data.token });
                }
            } catch (e) {
                setInvalidMsg(e.message);
                setIsInvalid(true);
                setLoading(false)
            }
        }
        else {
            try {
                setLoading(true)
                const data = await $crud.post("/auth/verifyPin", { username: state.username, userPin: otp, language: isGerms ? "de" : "en" });
                if (data.status) {
                    setLoading(false)
                    let tokenx = localStorage.getItem("firebaseToken")
                    let deviceId = localStorage.getItem("uniqueDeviceId")
                    let loginData = { username: state.username, password: state.password };
                    $user.login({ ...loginData, fcmId: tokenx, deviceId: deviceId }).then(async (res) => {
                        if (!res.status) {

                        } else {
                            const userLang = res?.user?.language || 'en';
                            localStorage.setItem("switch", userLang === "de" ? "2" : "1");
                            localStorage.setItem("language", userLang);
                            localStorage.removeItem("regiLang")
                            const startup = queueStartupNavigation(res?.user?.startupScreen);
                            dispatch({ type: RIGHT_TOP, rightTop: '' })
                            dispatch({ type: SET_OPEN_SIDE_BAR, payload: startup.sidebar })
                            dispatch({ type: SET_USER_LOGIN_TOKEN, status: res.token });
                        }
                    });
                    // setShowModal(true)
                }
                else {
                    setLoading(false)
                    setMsg(data.message)
                    setShowModalError(true)
                }
            } catch (err) {
                setLoading(false)
                setMsg(err.message)
                setShowModalError(true)
            }
        }
    }
    return (
        <div className='w-300 border border-2 border-#303030 security-pin'>
            <div className="kj-flex-1">
                <div className="security-pin__header">
                    <div>
                        <a
                            className="pointer"
                            onClick={() => history.goBack()}
                        >
                            <span className="material-symbols-outlined material-arrow-left">
                              keyboard_arrow_left
                            </span>
                        </a>
                    </div>
                    <div className="security-pin__title">
                        <p>{isGerms ? state.isResetAccount ? DE.rac : DE.register : state.isResetAccount ? EN.rac : EN.register}</p>
                    </div>
                </div>
            </div>
            <div className="security-pin__body">
                <div className="security-pin__intro">
                    <p className="security-pin__intro-text">{isGerms ? DE.register_pin_text : EN.register_pin_text}</p>
                </div>
                <div className="security-pin__otp">
                    <OtpInput
                        value={otp}
                        onChange={handleChange}
                        isInputNum
                        numInputs={6}
                        separator={<span>{` -- `}</span>}
                        inputStyle={{ height: 40, width: 40 }}
                    />
                </div>
                {otp.length == 6 ?
                    <button
                        type="button"
                        disabled={loading}
                        className="kj-btn kj-btn--outline"
                        onClick={_handleConfirm}
                    >
                        {loading ? (
                            <LoadingDots />
                        ) : isGerms ? (
                            DE.confirm
                        ) : (
                            EN.confirm
                        )}
                    </button>
                    :
                    <></>
                }
                {isInvalid && (
                    <p className="text-center small text-danger">{invalidMsg}</p>
                )}
            </div>
            <div className="kj-flex-1" />
            <Modal show={showModal} onHide={() => { }}>
                <Modal.Body>{isGerms ? DE.ac_ss : EN.ac_ss}</Modal.Body>
                <Modal.Footer>
                    <button type="button" className="kj-btn kj-btn--outline kj-btn--sm" onClick={() => {
                        setShowModal(false)
                        history.goBack()
                    }}>
                        {isGerms ? DE.ok : EN.ok}
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal show={errorModal} onHide={() => { }}>
                <Modal.Body>{msg}</Modal.Body>
                <Modal.Footer>
                    <button type="button" className="kj-btn kj-btn--outline kj-btn--sm" onClick={() => {
                        setShowModalError(false)
                    }}>
                        {isGerms ? DE.ok : EN.ok}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default SecurityPIN